import React from 'react';
import PropTypes from 'prop-types';
import SubmissionFieldConsult from './SubmissionFieldConsult';
import SubmissionFieldDate from './SubmissionFieldDate';
import SubmissionFieldDefault from './SubmissionFieldDefault';
import SubmissionFieldChoice from './SubmissionFieldChoice';
import SubmissionFieldStars from './SubmissionFieldStars';
import SubmissionFieldTextarea from './SubmissionFieldTextarea';
import SubmissionFieldTime from './SubmissionFieldTime';
import SubmissionFieldTimestamp from './SubmissionFieldTimestamp';
import styles from './styles';

const prepareSubmissionFieldLabel = ({ question }) =>
  (question.submissionView && question.submissionView.label) ||
  question.label ||
  '';

const prepareSubmissionFieldValueComponent = ({ context, question, value }) => {
  switch (true) {
    case 'textarea' === question.fieldType:
      return SubmissionFieldTextarea;
    case 'consult' === question.dataType:
      return SubmissionFieldConsult;
    case 'date' === question.dataType:
      return SubmissionFieldDate;
    case 'time' === question.dataType:
      return SubmissionFieldTime;
    case 'timestamp' === question.dataType:
      return SubmissionFieldTimestamp;
    case question.config.style === 'stars':
      return SubmissionFieldStars;
    case question.config.options !== null:
      return SubmissionFieldChoice;
    default:
      return SubmissionFieldDefault;
  }
};

const prepareSubmissionFieldValue = ({ context, question, value }) => {
  const SubmissionFieldComponent = prepareSubmissionFieldValueComponent({
    context,
    question,
    value,
  });
  return (
    <SubmissionFieldComponent
      context={context}
      question={question}
      value={value}
    />
  );
};

export default function SubmissionField({ context, question, value }) {
  return (
    <div className={styles.row}>
      <h4 className={styles.label}>
        {prepareSubmissionFieldLabel({ question })}
      </h4>
      <div className={styles.value}>
        {prepareSubmissionFieldValue({ question, context, value })}
      </div>
    </div>
  );
}

SubmissionFieldTextarea.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
